import { createRouter, createWebHistory } from 'vue-router'
import OnCheck from '../views/OnCheck.vue'
import OnDuty from '../views/OnDuty.vue'
import ClientView from '../views/ClientView.vue'

const routes = [
  {
    path: '/',
    name: 'OnCheck',
    component: OnCheck,
    meta: { title: '微信验证' },
  },
  {
    path: '/1',
    name: 'OnDuty',
    component: OnDuty,
    meta: { title: '电子值勤单' },
  },
  {
    path: '/client',
    name: 'ClientView',
    component: ClientView,
    meta: { title: '电子值勤单查询WEB应用' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  document.title = to.meta.title || '';
  // 仅当在微信浏览器打开时执行
  const isWechatBrowser = /MicroMessenger/i.test(navigator.userAgent);
  if (isWechatBrowser) {
    history.pushState(null, null, '/#');
    window.addEventListener('popstate', function () {
      history.pushState(null, null, '/#');
    });
  }
});

export default router
